var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTierLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13550_30671)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1915 55.6739C43.3697 55.6739 55.674 43.3696 55.674 28.1914C55.674 13.0132 43.3697 0.708862 28.1915 0.708862C13.0133 0.708862 0.708984 13.0132 0.708984 28.1914C0.708984 43.3696 13.0133 55.6739 28.1915 55.6739Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#DFDFDF",
    strokeOpacity: 0.6,
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1909 53.0795C41.9362 53.0795 53.079 41.9368 53.079 28.1914C53.079 14.4461 41.9362 3.30334 28.1909 3.30334C14.4456 3.30334 3.30273 14.4461 3.30273 28.1914C3.30273 41.9368 14.4456 53.0795 28.1909 53.0795Z",
    fill: "#C9C9C9",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1913 50.4355C40.4764 50.4355 50.4354 40.4765 50.4354 28.1914C50.4354 15.9064 40.4764 5.94739 28.1913 5.94739C15.9063 5.94739 5.94727 15.9064 5.94727 28.1914C5.94727 40.4765 15.9063 50.4355 28.1913 50.4355Z",
    fill: "#C9C9C9",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3368 29.9707C8.26591 29.2972 8.23047 28.6167 8.23047 27.9291C8.23047 16.9134 17.1621 7.98889 28.1707 7.98889C39.1793 7.98889 48.111 16.9205 48.111 27.9291C48.111 28.638 48.0755 29.3469 47.9976 30.0345",
    stroke: "#C9C9C9",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4886 13.6172L21.4354 20.9752L14.0137 14.0992L14.4886 13.6172Z",
    fill: "#D7B7B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29317 22.3645L18.9975 25.2567L9.12305 23.0167L9.29317 22.3645Z",
    fill: "#D7B7B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17188 32.5297L19.018 30.1904L9.34909 33.1818L9.17188 32.5297Z",
    fill: "#D7B7B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 41.3975L21.5064 34.4507L14.6234 41.8725L14.1484 41.3975Z",
    fill: "#D7B7B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8887 46.5935L25.7879 36.8962L23.5479 46.7636L22.8887 46.5935Z",
    fill: "#D7B7B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0619 46.721L30.7227 36.8678L33.714 46.5367L33.0619 46.721Z",
    fill: "#D7B7B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9285 41.7377L34.9746 34.3798L42.4035 41.2628L41.9285 41.7377Z",
    fill: "#D7B7B7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1242 32.9975L37.4199 30.0983L47.2944 32.3454L47.1242 32.9975Z",
    fill: "#D7B7B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2465 22.8254L37.4004 25.1717L47.0693 22.1732L47.2465 22.8254Z",
    fill: "#D7B7B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2701 13.9575L34.9121 20.9114L41.7881 13.4825L42.2701 13.9575Z",
    fill: "#D7B7B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.523 8.76865L30.6309 18.4659L32.8709 8.59143L33.523 8.76865Z",
    fill: "#D7B7B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3572 8.64099L25.6965 18.4942L22.7051 8.81821L23.3572 8.64099Z",
    fill: "#D7B7B7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13550_30671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3539 31.1898C33.3515 31.1898 37.5691 32.0684 37.5691 35.4579C37.5691 38.8488 33.3239 39.6961 28.3539 39.6961C23.3574 39.6961 19.1387 38.8176 19.1387 35.428C19.1387 32.0372 23.3838 31.1898 28.3539 31.1898Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13550_30671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3544 15.595C31.8962 15.595 34.7341 18.4331 34.7341 21.9741C34.7341 25.5151 31.8962 28.3545 28.3544 28.3545C24.8137 28.3545 21.9746 25.5151 21.9746 21.9741C21.9746 18.4331 24.8137 15.595 28.3544 15.595Z",
    fill: "white",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13550_30671",
    x: 9.13867,
    y: 26.1898,
    width: 38.4297,
    height: 28.5063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13550_30671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13550_30671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13550_30671",
    x: 4.07461,
    y: 2.69497,
    width: 48.5598,
    height: 48.5595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13550_30671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13550_30671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13550_30671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTierLogo);
export default __webpack_public_path__ + "static/media/noTierLogo.0528cabd4cdf7ba3259f0116004dd8ce.svg";
export { ForwardRef as ReactComponent };